import { Injectable } from '@angular/core';
import { AnalyticsService } from './analytics.service';

declare const mixpanel: any;

@Injectable()
export class MixpanelService {
  constructor(private analytics: AnalyticsService) {}

  init() {
    if (typeof mixpanel !== 'undefined') {
      this.analytics.pageTrack.subscribe((x: any) => this.pageTrack(x.path, x.location));
      this.analytics.linkTrack.subscribe((x: any) => this.linkTrack(x.query, x.action, x.properties));
      this.analytics.eventTrack.subscribe((x: any) => this.eventTrack(x.action, x.properties));
      this.analytics.setUsername.subscribe((x: string) => this.setUsername(x));
      this.analytics.setUserProperties.subscribe((x: any) => this.setUserProperties(x));
      this.analytics.setUserPropertiesOnce.subscribe((x: any) => this.setUserPropertiesOnce(x));
      this.analytics.setSuperProperties.subscribe((x: any) => this.setSuperProperties(x));
      this.analytics.setSuperPropertiesOnce.subscribe((x: any) => this.setSuperPropertiesOnce(x));
      this.analytics.setAlias.subscribe((x: string) => this.setAlias(x));
    }
  }

  pageTrack(path: string, location: any) {
    try {
      mixpanel.track('Page: ', { page: path, location: location });
    } catch (e) {
      return this.processError(e);
    }
  }

  linkTrack(query: string | HTMLElement, action: string, properties: any) {
    try {
      mixpanel.track_links(query, action, properties);
    } catch (e) {
      return this.processError(e);
    }
  }

  eventTrack(action: string, properties: any) {
    try {
      mixpanel.track(action, properties);
    } catch (e) {
      return this.processError(e);
    }
  }

  setUsername(userName: string) {
    try {
      mixpanel.identify(userName);
    } catch (e) {
      return this.processError(e);
    }
  }

  userLogout() {
    try {
      mixpanel.reset();
    } catch (e) {
      return this.processError(e);
    }
  }

  setUserProperties(properties: any) {
    try {
      mixpanel.people.set(properties);
    } catch (e) {
      return this.processError(e);
    }
  }

  setUserPropertiesOnce(properties: any) {
    try {
      mixpanel.people.set_once(properties);
    } catch (e) {
      return this.processError(e);
    }
  }

  setSuperProperties(properties: any) {
    try {
      mixpanel.register(properties);
    } catch (e) {
      return this.processError(e);
    }
  }

  setSuperPropertiesOnce(properties: any) {
    try {
      mixpanel.register_once(properties);
    } catch (e) {
      return this.processError(e);
    }
  }

  setAlias(alias: any) {
    try {
      mixpanel.alias(alias);
    } catch (e) {
      return this.processError(e);
    }
  }

  private processError(e) {
    if (!(e instanceof ReferenceError)) {
      throw e;
    }
  }
}
